import _ from 'lodash';
import type { TPaddingObjectFilterCriteria } from '@timeedit/types';
import { Icon, type TEIOption, TEInput } from '@timeedit/ui-components';

type Props = {
  index: number;
  impactedObject: TPaddingObjectFilterCriteria & { impacted?: boolean };
  typeOptions: TEIOption[];
  onCriteriaUpdated: (index: number, criteria: any) => void;
  showImpact: boolean;
  onDelete?: () => void;
};

const ExtIdSelect = ({
  index,
  impactedObject,
  typeOptions,
  onCriteriaUpdated,
  showImpact,
  onDelete,
}: Props) => {
  return (
    <div className="field-value">
      <div className="wrapper">
        <TEInput.Select
          data-testid={`object-type-${index}`}
          label="Object type"
          value={
            impactedObject.typeId
              ? impactedObject.typeId?.toString()
              : undefined
          }
          options={typeOptions}
          onChange={(val) =>
            onCriteriaUpdated(index, {
              typeId: Number(val),
            })
          }
          placeholder="Select"
        />
        <TEInput.Input
          data-testid={`extids-${index}`}
          label="Ext. IDs"
          value={(impactedObject.objectExtIds ?? []).join(',')}
          onChange={(val) =>
            onCriteriaUpdated(index, {
              objectExtIds: val ? val.split(',') : [],
            })
          }
          placeholder="extId1,extId2,..."
          allowClear
        />
      </div>
      <div className="wrapper">
        {showImpact && (
          <TEInput.Switch
            checked={impactedObject.impacted}
            onChange={(val) => {
              onCriteriaUpdated(index, { impacted: val });
            }}
            label="Impacted"
          />
        )}
        {onDelete && (
          <Icon id="DeleteOutlined" alt="Delete" onClick={onDelete} />
        )}
      </div>
    </div>
  );
};

export default ExtIdSelect;
